var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInRangeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422.799,
    height: 422.799,
    viewBox: "0 0 111.866 111.866",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.545 51.328v31.025M90.49 51.328v31.026M90.476 26.97v16.398M79.96 26.943V43.34M56.282 26.945v16.398M68.112 26.93v16.398",
    strokeWidth: 6.465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.802 30.456h85.813",
    strokeWidth: 7.065
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.558 26.928v16.398M33.243 26.95v16.398M44.56 26.927v16.398",
    strokeWidth: 6.465
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.746 66.802h54.568M42.211 53.724L29.196 66.74l12.847 13.195M69.54 79.799l13.173-12.855-12.684-13.35",
    strokeWidth: 6.645
  }))));
}
export default SvgInRangeIcon;